import type { FC } from 'react'
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'
import { Compass03 } from '@untitled-ui/icons-react'

/**
 * Icône du tour, la même dans la bulle et sur l'entrée de la sidenav. Elle passe par `SvgIcon`,
 * comme les autres icônes de la sidenav, pour en suivre la taille (thème × densité). Le cercle de
 * Compass03 est centré en (12, 11) : la `viewBox` le redescend d'une unité pour qu'il s'aligne sur
 * les autres icônes, centrées en (12, 12).
 */
export const ProductTourIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 -1 24 24" aria-hidden {...props}>
    <Compass03 />
  </SvgIcon>
)
